import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["volume", "preview", "concentration", "size", "sizeLabel", "penHelp", "syringeHelp"];
  static values = { penSize: String, syringeSize: String };

  connect() {
    this.refresh();
  }

  device(event) {
    const pen = event.target.value === "pen";
    this.sizeLabelTarget.textContent = pen ? "Pen" : "Syringe";
    this.penHelpTarget.hidden = !pen;
    this.syringeHelpTarget.hidden = pen;
    this.sizeTarget.value = pen ? this.penSizeValue : this.syringeSizeValue;
  }

  refresh() {
    const volume = Number(Number(this.volumeTarget.value).toFixed(4));
    const valid = Number.isFinite(volume) && volume > 0 && volume < 1000000;
    this.previewTarget.hidden = !valid;
    if (!valid) return;

    this.concentrationTargets.forEach((output) => {
      const concentration = Number(output.dataset.amount) / volume;
      output.textContent = `${Number(concentration.toFixed(4))} ${output.dataset.unit}/mL`;
    });
  }
}
